module.exports = __webpack_public_path__ + "img/22.8133a02f.jpg";